var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-picker-mobile-container" },
    [
      _c("smooth-picker", {
        ref: "locationPicker",
        attrs: {
          data: _vm.setLocationOptions,
          change: _vm.handleLocationChange
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c("BaseButton", {
            attrs: {
              title: "Choose",
              classNames: ["button--modifier", "inline-7"]
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.handleChoose($event)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "inline-separator" }),
          _vm._v(" "),
          _c("BaseButton", {
            attrs: {
              title: "Remove",
              classNames: ["button--modifier", "inline-7"]
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.handleRemoveLocation($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f324f0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f324f0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseLocationPickerMobile.vue
// module id = null
// module chunks = 